/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.5",
    versionName: "0.2.0-nightly.2025.7.5",
    versionChannel: "nightly",
    buildDate: "2025-07-05T00:07:20.452Z",
    commitHash: "6781cb52697c005e21fb68532ac1fa99adda5c98",
};
